var render = function () {
  var _vm$configuration$app;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.graphicByComponent[_vm.activeComponent],
      expression: "graphicByComponent[activeComponent]"
    }],
    staticClass: "graphics-controller__container"
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showEditor,
      expression: "showEditor"
    }],
    ref: "editorContainer",
    staticClass: "graphics-controller__detailed-editor-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showEditor,
      expression: "showEditor"
    }],
    staticClass: "graphics-controller__detailed-editor-background",
    style: _vm.swatchBackgroundStyle
  }), _c('div', {
    staticClass: "graphics-controller__detailed-editor-size-delimiter"
  }, [_c('div', {
    staticClass: "graphics-controller__detailed-editor"
  }, [_vm.graphicByComponent[_vm.activeComponent] && _vm.editorVisible ? _c('graphic-svg-editor', {
    ref: "svgEditor",
    staticClass: "graphics-controller__svg-graphic",
    attrs: {
      "svg-content-str": _vm.svgContentStr
    }
  }) : _vm._e()], 1)]), !_vm.isMobile && (_vm$configuration$app = _vm.configuration.apparel_settings) !== null && _vm$configuration$app !== void 0 && _vm$configuration$app.enable_graphic_zoom && _vm.hasUgc && !_vm.isSplashPageModalOpen ? _c('zoom-control', {
    attrs: {
      "zoomValue": _vm.zoomValue,
      "min": _vm.minValue,
      "max": _vm.maxValue,
      "step": "0.1",
      "controlLeftText": "-",
      "controlRightText": "+",
      "customsClasses": "ugc-zoom-control-apparel"
    },
    on: {
      "onChange": _vm.onChange,
      "zoomOut": _vm.zoomOut,
      "zoomIn": _vm.zoomIn
    }
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "graphics-controller__spinner-wrapper--fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isLoading,
      expression: "isLoading"
    }],
    staticClass: "graphics-controller__spinner-wrapper"
  }, [_c('base-spinner')], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showQuickAdjust,
      expression: "showQuickAdjust"
    }],
    staticClass: "graphics-controller__zoom-in"
  }, [!_vm.editorVisible && !_vm.isSplashPageModalOpen ? _c('button', {
    staticClass: "btn customs-rounded-button",
    on: {
      "click": _vm.onZoomIn
    }
  }, [_vm._v("\n      " + _vm._s(_vm.translations.apparel && _vm.translations.apparel.graphicZoomIn) + "\n    ")]) : _vm._e(), _vm.editorVisible && !_vm.isSplashPageModalOpen ? _c('button', {
    staticClass: "btn customs-rounded-button customs-rounded-button--primary",
    on: {
      "click": _vm.onZoomToggle
    }
  }, [_vm._v("\n      " + _vm._s(_vm.translations.apparel && _vm.translations.apparel.graphicZoomOut) + "\n    ")]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }